// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__173X5","logo":"styles_logo__3vEVs"};